export class SharedLinks {
    constructor(http) {
      this.http = http;
    }
  
    fetchById(id) {
      try {
        const data = this.http.get(`share_link/${id}/`);
        return data;
      } catch (error) {
        return error;
      }
    }
  }
